import TemplateComponent from "../../containers/template_page/template_component/template_component";

class RedirectTo extends TemplateComponent {
    componentRender(data) {
        window.location.href = data.link;
    }
}

export default RedirectTo;
